var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Differentiators/Time/Active/24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Differentiators/Time/Active/24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Time",
    transform: "translate(3.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8571429,11.3095238 C17.8571429,15.9118088 14.1260945,19.6428571 9.52380952,19.6428571 C4.92152455,19.6428571 1.19047619,15.9118088 1.19047619,11.3095238 C1.19047619,6.70723883 4.92152455,2.97619048 9.52380952,2.97619048 C14.1260945,2.97619048 17.8571429,6.70723883 17.8571429,11.3095238 Z",
    id: "Stroke-3",
    stroke: "#001823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76190476,2.60312671 L0.816742577,6.54761905 C-0.273325466,5.45665806 -0.271169051,3.69193164 0.816742577,2.60312671 C1.90573241,1.51432177 3.67075851,1.51216572 4.76190476,2.60312671",
    id: "Fill-5",
    fill: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2302066,6.33064086 L14.2857143,2.38547867 C15.3766753,1.29541063 17.1414017,1.29756705 18.2302066,2.38547867 C19.3190116,3.47446851 19.3211676,5.23949461 18.2302066,6.33064086",
    id: "Fill-7",
    fill: "#DB3725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7142857,11.3095238 C10.7142857,11.9664811 10.1815953,12.5 9.52380952,12.5 C8.86685224,12.5 8.33333333,11.9664811 8.33333333,11.3095238 C8.33333333,10.6517381 8.86685224,10.1190476 9.52380952,10.1190476 C10.1815953,10.1190476 10.7142857,10.6517381 10.7142857,11.3095238",
    id: "Fill-18",
    fill: "#001823"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#001823",
    x: 7.73809524,
    y: 0,
    width: 3.57142857,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#001823",
    transform: "translate(9.500000, 1.488095) rotate(-270.000000) translate(-9.500000, -1.488095) ",
    points: "8.30952381 1.19047619 10.6904762 1.19047619 10.6904762 1.78571429 8.30952381 1.78571429"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#001823",
    x: 9.22619048,
    y: 5.35714286,
    width: 1,
    height: 5.95238095,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14285714,8.92857143 L7.14285714,8.92857143 C7.3072276,8.92857143 7.44047619,9.06182001 7.44047619,9.22619048 L7.44047619,13.3928571 C7.44047619,13.5572276 7.3072276,13.6904762 7.14285714,13.6904762 L7.14285714,13.6904762 C6.97848668,13.6904762 6.8452381,13.5572276 6.8452381,13.3928571 L6.8452381,9.22619048 C6.8452381,9.06182001 6.97848668,8.92857143 7.14285714,8.92857143 Z",
    id: "Rectangle-Copy-2",
    fill: "#001823",
    transform: "translate(7.142857, 11.309524) rotate(-270.000000) translate(-7.142857, -11.309524) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.f223bc4614cd13352cc46a89d22a3082.svg";
export { ForwardRef as ReactComponent };